import { userActionTypes } from '../actions/types';
import { userService } from '../services';

let usersRequestSequence = 0;

const isExpiredTokenError = error => (
  error
  && (
    error.code === 'invalidToken'
    || error.name === 'TokenExpiredError'
    || error.error === 'jwt expired'
    || error.message === 'jwt expired'
  )
);

export const userActions = {
  login,
  logout,
  register,
  getAll,
  getUser,
  statistics,
  details,
  newDetails,
  update,
  delete: _delete,
  authenticate,
  confirmMobile,
  resendConfirmationSMS,
  forgotPassword,
  resetPassword,
  resetState,
  changeProfilePicture,
  changeTheme,
  getDesigns,
  getDashboardStats,
};

function resetState() {
  return dispatch => dispatch({ type: userActionTypes.RESET_STATE });
}

function login(username, password) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      user => {
        dispatch(success(user));
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request(user) {
    return { type: userActionTypes.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userActionTypes.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userActionTypes.LOGIN_FAILURE, error };
  }
}

function logout() {
  return async (dispatch, getState) => {
    const { loggingOut } = getState().authentication;

    if (!loggingOut) {
      try {
        dispatch({ type: userActionTypes.LOGOUT_REQUEST });
        await userService.logout();
        return dispatch({ type: userActionTypes.LOGOUT });
      } catch (error) {
        return dispatch({ type: userActionTypes.LOGOUT_FAILURE });
      }
    }
  };
}

function register(user) {
  return dispatch => {
    dispatch(request(user));

    userService.register(user).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request(user) {
    return { type: userActionTypes.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userActionTypes.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userActionTypes.REGISTER_FAILURE, error };
  }
}

function confirmMobile(props) {
  return dispatch => {
    dispatch(request());

    userService.confirmMobile(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.CONFIRM_MOBILE_REQUEST };
  }
  function success() {
    return { type: userActionTypes.CONFIRM_MOBILE_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.CONFIRM_MOBILE_FAILURE, error };
  }
}

function resendConfirmationSMS(props) {
  return dispatch => {
    dispatch(request());

    props.resend = true;

    userService.resendConfirmationSMS(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.RESEND_CONFIRMATION_SMS_REQUEST };
  }
  function success() {
    return { type: userActionTypes.RESEND_CONFIRMATION_SMS_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.RESEND_CONFIRMATION_SMS_FAILURE, error };
  }
}

function forgotPassword(props) {
  return dispatch => {
    dispatch(request());

    userService.forgotPassword(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.FORGOT_PASSWORD_REQUEST };
  }
  function success() {
    return { type: userActionTypes.FORGOT_PASSWORD_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.FORGOT_PASSWORD_FAILURE, error };
  }
}

function resetPassword(props) {
  return dispatch => {
    dispatch(request());

    userService.resetPassword(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.RESET_PASSWORD_REQUEST };
  }
  function success() {
    return { type: userActionTypes.RESET_PASSWORD_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.RESET_PASSWORD_FAILURE, error };
  }
}

function getAll(count) {
  return (dispatch, getState) => {
    dispatch(request());

    userService.getAll().then(
      users => {
        const usersCount = users.length;
        dispatch(success(users, usersCount, count))
      },
      error => dispatch(failure(error, getState().authentication.pendingRefreshingToken)),
    );
  };

  function request() {
    return { type: userActionTypes.GETALL_REQUEST };
  }
  function success(users, usersCount, count) {
    return { type: userActionTypes.GETALL_SUCCESS, users, usersCount, count };
  }
  function failure(error, pendingRefreshToken) {
    if (isExpiredTokenError(error)) {
      if (pendingRefreshToken) {
        return {
          type: userActionTypes.PENDING_REFRESH_TOKEN,
          error: error.error,
        };
      } else {
        return { type: userActionTypes.INVALID_TOKEN, error: error.error };
      }
    } else {
      return { type: userActionTypes.GETALL_FAILURE, error: error.error };
    }
  }
}

function statistics(query) {
  return (dispatch, getState) => {
    dispatch(request());

    userService.statistics(query).then(
      users => {
        dispatch(success(users))
      },
      error => dispatch(failure(error, getState().authentication.pendingRefreshingToken)),
    );
  };

  function request() {
    return { type: userActionTypes.STATISTICS_REQUEST };
  }
  function success(users) {
    return { type: userActionTypes.STATISTICS_SUCCESS, users };
  }
  function failure(error, pendingRefreshToken) {
    if (isExpiredTokenError(error)) {
      if (pendingRefreshToken) {
        return {
          type: userActionTypes.PENDING_REFRESH_TOKEN,
          error: error.error,
        };
      } else {
        return { type: userActionTypes.INVALID_TOKEN, error: error.error };
      }
    } else {
      return { type: userActionTypes.STATISTICS_FAILURE, error: error.error };
    }
  }
}

function getUser(userId) {
  return (dispatch, getState) => {
    dispatch(request());

    userService.getUser(userId).then(
      user => {
        dispatch(success(user))
      },
      error => dispatch(failure(error, getState().authentication.pendingRefreshingToken)),
    );
  };

  function request() {
    return { type: userActionTypes.GET_REQUEST };
  }
  function success(user) {
    return { type: userActionTypes.GET_SUCCESS, user };
  }
  function failure(error, pendingRefreshToken) {
    if (isExpiredTokenError(error)) {
      if (pendingRefreshToken) {
        return {
          type: userActionTypes.PENDING_REFRESH_TOKEN,
          error: error.error,
        };
      } else {
        return { type: userActionTypes.INVALID_TOKEN, error: error.error };
      }
    } else {
      return { type: userActionTypes.GET_FAILURE, error: error.error };
    }
  }
}

function details(query, clear) {
  return (dispatch, getState) => {
    dispatch(request());
    
    // Validate and set pagination parameters
    const skip = clear ? 0 : (query.skip || 0);
    const limit = (query && (query.limit || query.limit === 0)) ? (query.limit === 0 ? 500 : query.limit) : 500;
    
    // Add validation for skip and limit
    if (skip < 0 || limit < 1) {
      dispatch(failure({ error: 'Invalid pagination parameters' }));
      return;
    }

    // Get last successful fetch point from state
    const lastSuccessfulFetch = getState().user.lastSuccessfulFetch || 0;
    const currentSkip = clear ? 0 : Math.max(skip, lastSuccessfulFetch);

    userService.details({ skip: currentSkip, limit })
      .then(users => {
        const currentUsers = getState().user.users;
        const updatedUsers = clear ? users : [...currentUsers, ...users];
        
        // Update last successful fetch point
        dispatch(success(updatedUsers, currentSkip, limit, clear));
        
        // Only fetch next page if we received exactly 'limit' number of users and it's not a clear request
        if (!clear && users.length === limit && users.length > 0) {
          // Check if we've received new users before making the next request
          const previousTotal = currentUsers.length;
          const newTotal = updatedUsers.length;
          
          if (newTotal > previousTotal) {
            dispatch(details({ skip: currentSkip + limit, limit }));
          } else {
            console.log('No new users received, stopping pagination');
          }
        } else {
          console.log(`All users loaded successfully. Total count: ${updatedUsers.length}`);
        }
      })
      .catch(error => {
        console.error('Error fetching users:', error);
        
        // If we have some users loaded, we can continue from last successful point
        const currentUsers = getState().user.users;
        if (currentUsers.length > 0) {
          console.log(`Error occurred. Continuing from last successful point: ${currentSkip}`);
          // Retry from last successful point after a short delay
          setTimeout(() => {
            dispatch(details({ skip: currentSkip, limit }));
          }, 2000);
        }
        
        dispatch(failure(error, getState().authentication.pendingRefreshingToken));
      });
  };

  function request() {
    return { type: userActionTypes.DETAILS_REQUEST };
  }
  function success(users, skip, limit, clear) {
    return { 
      type: userActionTypes.DETAILS_SUCCESS, 
      users, 
      skip, 
      limit, 
      clear,
      lastSuccessfulFetch: skip // Store the last successful fetch point
    };
  }
  function failure(error, pendingRefreshToken) {
    if (isExpiredTokenError(error)) {
      if (pendingRefreshToken) {
        return {
          type: userActionTypes.PENDING_REFRESH_TOKEN,
          error: error.error,
        };
      } else {
        return { type: userActionTypes.INVALID_TOKEN, error: error.error };
      }
    } else {
      return { type: userActionTypes.DETAILS_FAILURE, error: error.error };
    }
  }
}

function newDetails({ page = 1, limit = 10, search = '', planStatus = '' }) {
  return async (dispatch, getState) => {
    const requestId = ++usersRequestSequence;
    try {
      dispatch(request(requestId));
      const response = await userService.newDetails({ page, limit, search, planStatus });
      
      if (!response || !response.data) {
        throw new Error('Invalid users response from the server');
      }

      dispatch({
        type: userActionTypes.FETCH_USERS_SUCCESS,
        payload: {
          users: response.data,
          page: Number(response.page),
          totalPages: Number(response.totalPages),
          total: Number(response.total)
        },
        meta: { requestId },
      });
    } catch (error) {
      const tokenExpired = isExpiredTokenError(error);

      if (tokenExpired) {
        const pendingRefreshToken = getState().authentication.pendingRefreshingToken;
        dispatch(pendingRefreshToken
          ? {
              type: userActionTypes.PENDING_REFRESH_TOKEN,
              error: error.error || error.message,
            }
          : {
              type: userActionTypes.INVALID_TOKEN,
              error: error.error || error.message,
            });
        return;
      }

      dispatch({
        type: userActionTypes.FETCH_USERS_FAILURE,
        meta: { requestId },
        error: (error && (error.error || error.message)) || 'Unable to load users'
      });
    }
  };

  function request(requestId) {
    return {
      type: userActionTypes.FETCH_USERS_REQUEST,
      meta: { requestId },
    };
  }
}

function update(user) {
  return async (dispatch, getState) => {
    dispatch(request());

    try {
      const updatedUser = await userService.update(user);
      dispatch(success());
      dispatch(getUser(user.userId));
      return updatedUser;
    } catch (error) {
      dispatch(
        _refreshTokenOnFailure(
          error,
          userActionTypes.UPDATE_FAILURE,
          getState().authentication.pendingRefreshingToken,
        ),
      );
      throw error;
    }
  };

  function request() {
    return { type: userActionTypes.UPDATE_REQUEST };
  }
  function success() {
    return { type: userActionTypes.UPDATE_SUCCESS };
  }
}

function getDesigns(userId) {
  return async (dispatch, getState) => {
    dispatch(request());

    try {
      const designs = await userService.getDesigns(userId);
      dispatch(success(designs));
      return designs;
    } catch (error) {
      dispatch(
        _refreshTokenOnFailure(
          error,
          userActionTypes.GET_DESIGNS_FAILURE,
          getState().authentication.pendingRefreshingToken,
        ),
      );
      throw error;
    }
  };

  function request() {
    return { type: userActionTypes.GET_DESIGNS_REQUEST };
  }
  function success(designs) {
    return { type: userActionTypes.GET_DESIGNS_SUCCESS, designs };
  }
}

function changeProfilePicture(files) {
  return (dispatch, getState) => {
    dispatch(request());

    const user = getState().authentication.user;
    let userId = null;
    if (user.role === 'client') {
      userId = user.userId;
    }

    userService.changeAvatar(userId, files).then(
      resource => {
        dispatch(success(resource));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            userActionTypes.CHANGE_PROFILE_PICTURE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: userActionTypes.CHANGE_PROFILE_PICTURE_REQUEST };
  }
  function success(resource) {
    return { type: userActionTypes.CHANGE_PROFILE_PICTURE_SUCCESS, resource };
  }
}

function changeTheme(theme) {
  return (dispatch, getState) => {
    dispatch(request());

    let userId = getState().authentication.user.userId;

    userService.update({ userId, theme }).then(
      user => {
        dispatch(success());
        dispatch({ type: userActionTypes.UPDATE_USER, user }); // For update user in authentication state
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            userActionTypes.UPDATE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: userActionTypes.UPDATE_REQUEST };
  }
  function success() {
    return { type: userActionTypes.UPDATE_SUCCESS };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    userService.delete(id).then(
      () => {
        dispatch(success(id));
      },
      error => {
        dispatch(failure(id, error));
      },
    );
  };

  function request(id) {
    return { type: userActionTypes.DELETE_REQUEST, id };
  }
  function success(id) {
    return { type: userActionTypes.DELETE_SUCCESS, id };
  }
  function failure(id, error) {
    return { type: userActionTypes.DELETE_FAILURE, id, error };
  }
}

function authenticate({ password }) {
  return (dispatch, getState) => {
    dispatch(request());

    userService.authenticate(password).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            userActionTypes.AUTHENTICAT_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: userActionTypes.AUTHENTICAT_REQUEST };
  }
  function success() {
    return { type: userActionTypes.AUTHENTICAT_SUCCESS };
  }
}

function getDashboardStats() {
  return dispatch => {
    dispatch(request());
    
    userService.getDashboardStats().then(
      stats => {
        dispatch(success(stats));
      },
      error => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: userActionTypes.GET_DASHBOARD_STATS_REQUEST };
  }
  function success(stats) {
    return { type: userActionTypes.GET_DASHBOARD_STATS_SUCCESS, stats };
  }
  function failure(error) {
    return { type: userActionTypes.GET_DASHBOARD_STATS_FAILURE, error };
  }
}

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (isExpiredTokenError(error)) {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};
